export const Menulist=[
    {
        title:"Home",
        url:"/"
    },
    {
        title:"Classical",
        url:"/classical"
    },
    {
        title:"Light Music",
        url:"/lightmusic"
    },
    {
        title:"Contact",
        url:"/contact"
    },

];
